/**
 * Serialises arrays as repeated keys (`?ids=a&ids=b`), which is what the backend's
 * `@Transform(value => Array.isArray(value) ? value : [value])` DTOs expect.
 *
 * Extracted from infoboard.api.ts rather than reaching for `qs`: kindergarten.api.ts
 * imports qs but it is not a declared dependency, only transitively present.
 */
export const repeatArraySerializer = (params: Record<string, unknown>): string => {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach(item => searchParams.append(key, String(item)));
    } else if (value !== undefined && value !== null && value !== '') {
      searchParams.append(key, String(value));
    }
  });
  return searchParams.toString();
};
